<template>
  <div>
    <div style="margin-top: 10rem; display: block;" v-if="showLoading">
      <div class="section-loader">
        <img src="/loader-circle.gif" alt="" />
        <span>{{ $t("Loading") }}</span>
      </div>
    </div>
    <div id="LandingBookings" class="row" v-if="Vendor && !showLoading">
      <div id="Step1" class="m-0 p-0 col-md-12" v-if="step == 1">
        <div class="header row w-100" v-if="selected.show_dep_and_members">
          <div class="col-md-6 departments">
            <label for="departments">
              <template v-if="$i18n.locale == 'en'">{{
                Config.options.choose_department_label.en
              }}</template>
              <template v-else-if="$i18n.locale == 'fr'">{{
                Config.options.choose_department_label.fr
              }}</template>
              <template v-else-if="$i18n.locale == 'ar'">{{
                Config.options.choose_department_label.ar
              }}</template>
              <template v-else>{{
                Config.options.choose_department_label.default
              }}</template>
            </label>
            <v-select
              :options="vendorDepartment"
              :disabled="vendorDepartment.length <= 1"
              v-model="selected.department"
              label="name"
              @input="testOnDepartment"
              class="select dep_select"
              id="departments"
            ></v-select>
          </div>
          <div
            class="col-md-6 members"
            v-if="
              selected.department &&
                selected.department.can_select_member == true &&
                selected.department.dep_members.length > 0 &&
                displayMember
            "
          >
            <label for="member">
              <template v-if="$i18n.locale == 'en'">{{
                Config.options.choose_member_label.en
              }}</template>
              <template v-else-if="$i18n.locale == 'fr'">{{
                Config.options.choose_member_label.fr
              }}</template>
              <template v-else-if="$i18n.locale == 'ar'">{{
                Config.options.choose_member_label.ar
              }}</template>
              <template v-else>{{
                Config.options.choose_member_label.default
              }}</template>
            </label>
            <v-select
              :options="memberArray"
              :disabled="selected.department.dep_members.length <= 1"
              placeholder="--"
              v-model="selected.member"
              label="fullname"
              @input="testOnMember"
              class="select member_select"
              id="member"
              v-if="selected.department"
            ></v-select>
            <v-select
              :disabled="true"
              v-model="selected.member"
              label="fullname"
              class="select member_select"
              v-else
            ></v-select>
          </div>
        </div>

        <div class="services">
          <div class="search internalID">
            <input
                type="search"
                v-model="internalID"
                :placeholder="$t('Customer.InternalId')"
            />
          </div>
        </div>

        <div class="services" v-if="displayServices">
          <label for="member">{{ $t("ChooseServices") }}</label>
          <div class="search">
            <input
              type="search"
              v-model="searchQuery"
              :placeholder="$t('FindYourService')"
            />
            <button class="btn">
              <font-awesome-icon class="icon" icon="search" />
            </button>
          </div>

          <div
            v-for="(service, index) in filteredAndSorted"
            :key="'queueService' + service.id"
          >
            <div style="display: flex; justify-content: space-between">
              <label :for="'queue_service' + service.id" class="checkbox">
                {{ service.title }}
                <input
                  @click="
                    getQuantityServices(index, service.id, service.duration)
                  "
                  :id="'queue_service' + service.id"
                  name="checkbox-group"
                  type="checkbox"
                />
                <span class="checkbox__mark">
                  <svg
                    width="25"
                    height="18"
                    viewBox="0 0 25 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.13449 12.7269L22.2809 0L25 2.64085L9.13449 18L0 9.15702L2.71912 6.51624L9.13449 12.7269Z"
                      fill="#000000"
                    />
                  </svg>
                </span>
              </label>
              <div :class="'plus' + index" style="display: none; margin: auto">
                <div
                  v-for="seleted_serv in selected.services"
                  :key="'A' + seleted_serv.id"
                >
                  <div
                    v-if="seleted_serv.id === service.id"
                    style="display: flex"
                  >
                    <button
                      @click="
                        seleted_serv.qte > 1 ? (seleted_serv.qte -= 1) : ''
                      "
                      class="buttonQte"
                    >
                      -
                    </button>
                    <div style="font-family: sans-serif">
                      {{ seleted_serv.qte }}
                    </div>
                    <button
                      @click="
                        seleted_serv.qte < 9 ? (seleted_serv.qte += 1) : ''
                      "
                      class="buttonQte"
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="space-under"></div>
        </div>
      </div>

      <div id="Step2" class="w-100 m-0 p-0" v-else-if="step == 2">
        <div class="section-loader" v-if="loading_dates">
          <img src="/loader-circle.gif" alt="" />
        </div>
        <div v-else>
          <div class="calendar text-center row m-0 p-0">
            <div class="col-md-12 text-center mb-4">
              <label for="member">{{ $t("ChooseDateAndSlots") }}</label>
            </div>
            <div class="col-md-6">
                  <datepicker
                    class="datePicker"
                    v-model="selected.date"
                    :format="'yyyy MM dd'"
                    :disabled-dates="datepicker_config.disabled_dates"
                    :monday-first="true"
                    :inline="true"
                    :language="datepicker_config.language"
                    @input="getAvailableSlots()"
                  ></datepicker>
            </div>
            <div class="col-md-6 slots">
              <div class="section-loader" v-if="loading_slots">
                <img src="/loader-circle.gif" alt="" />
              </div>
              <div v-else>
                <div
                  v-for="slot in booking_slots"
                  :key="'slots' + slot.slot"
                  class="slot"
                  :class="
                    slot.active == 1
                      ? slot.slot == selected.slot
                        ? 'slot_active slot_selected'
                        : 'slot_active'
                      : 'slot_disabled'
                  "
                  @click="selected.slot = slot.slot"
                  v-show="booking_slots.length"
                >
                  {{ slot.slot }}
                </div>
                <div class="slot slot-danger" v-if="!booking_slots.length">
                  {{ $t("NoSlotsYet") }}
                </div>
              </div>
            </div>
          </div>
          <div class="space-under2"></div>
          <!-- <div class="slots">
                    <div class="section-loader" v-if="loading_slots">
                        <img src="/loader-circle.gif" alt="">
                    </div>
                    <div v-else>
                        <div 
                            v-for="slot in booking_slots" :key="'slots'+slot.slot"
                            class="slot" 
                            :class="
                                slot.active==1?
                                    slot.slot==selected.slot?
                                        'slot_active slot_selected'
                                    :
                                        'slot_active'
                                :'slot_disabled'
                            "
                            @click="selected.slot = slot.slot"
                            v-show="booking_slots.length"
                        >
                            {{slot.slot}}
                        </div>
                        <div class="slot slot-danger" v-if="!booking_slots.length">
                            il n'y a pas de créneaux disponibles pour cette date.
                        </div>
                    </div>
                </div> -->
        </div>
      </div>

      <div class="buttons yaraab">
        <button class="button mr-2" @click="backBtn()">
          {{ $t("Return") }}
        </button>

        <button
          class="button button-filled ml-2"
          @click="
            step++;
            specifyBookingDays();
          "
          v-if="selected.services.length && step == 1"
        >
          {{ $t("Next") }}
        </button>
        <button
          class="button button-filled ml-2"
          v-else-if="step == 1"
          style="cursor: not-allowed; opacity: 0.7"
        >
          {{ $t("Next") }}
        </button>

        <button
          class="button button-filled ml-2"
          @click="bookAppointment()"
          v-if="selected.services.length && selected.slot && step == 2 && bookEnabled"
        >
          {{ $t("Confirm") }}
        </button>
        <button
          class="button button-filled ml-2"
          v-else-if="step == 2"
          style="cursor: not-allowed; opacity: 0.7"
        >
          {{ $t("Confirm") }}
        </button>
      </div>
      <Modal
        :active="modal.active"
        :type="modal.type"
        :title="modal.title"
        :hint="modal.hint"
        :message="modal.message"
        :confirmationButton="modal.confirmationButton"
        @confirm="ModalConfirmed"
      />
      <Modal
        :active="danger_modal.active"
        :type="danger_modal.type"
        :title="danger_modal.title"
        :hint="danger_modal.hint"
        :message="danger_modal.message"
        :confirmationButton="danger_modal.confirmationButton"
        @confirm="DangerModalConfirmed"
      />
      <Modal
          :active="internalIDModal.active"
          :type="internalIDModal.type"
          :title="internalIDModal.title"
          :hint="internalIDModal.hint"
          :message="internalIDModal.message"
          :confirmationButton="internalIDModal.confirmationButton"
          @confirm="InternalIDModalConfirmed"
      />
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { vendorsService, bookingService } from "/src/_services";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { en, ar, fr } from "vuejs-datepicker/dist/locale";

import Modal from "../modals/Popup.vue";

Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

Date.prototype.removeDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() - days);
  return date;
};

export default {
  data: () => ({
    showLoading: false,
    vendorDepartment: [],
    disabledDays: [],
    formValues: [],
    departmentFiltered: [],
    memberArray: [],
    must_select_member: 0,
    displayMember: false,
    displayServices: false,
    searchQuery: "",
    internalID: "",
    loading: true,
    loading_dates: false,
    loading_slots: false,
    step: 1,
    datepicker_config: {
      today: moment().format("YYYY-MM-DD"),
      language: fr,
      disabled_dates: {
        to: new Date().removeDays(1),
        from: null,
        days: [],
        ranges: [],
      },
    },
    holidays: [],
    booking_days: [],
    booking_slots: [],
    services: [],
    selected: {
      show_dep_and_members: true,

      department: null,
      member: null,
      services: [],
      date: new Date(),
      slot: null,
    },
    modal: {
      active: false,
      type: "success",
      title: "Rendez-vous pris avec succès",
      hint: "10:30, Le 30 Janvier 2020",
      message:
        "Rendez-vous pris avec succès, nous vous avons déjà envoyé un SMS de confirmation et nous vous le rappellerons par SMS quelques heures avant le rendez-vous. Merci",
      confirmationButton: "Continuer",
    },
    danger_modal: {
      active: false,
      type: "danger",
      title: "Ouups",
      hint: "Une erreur s'est produite",
      message:
        "Une erreur s'est produite, veuillez réessayer plus tard ou contactez-nous",
      confirmationButton: "Fermer",
    },
    internalIDModal: {
      active: false,
      type: "danger",
      title: "Champs obligatoire",
      hint: "",
      message:
          "Merci de saisie le numéro de dossier.",
      confirmationButton: "Fermer",
    },
    bookEnabled: true
  }),
  components: {
    Datepicker,
    Modal,
  },
  props: {
    Vendor: Object,
    User: Object,
  },
  computed: {
    filteredAndSorted() {
      // function to compare names
      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }

      return this.services
        .filter((user) => {
          return user.title
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase());
        })
        .sort(compare);
    },
  },
  mounted() {
    //get department by Id
    this.showLoading = true;
    vendorsService
      .getDepartmentById(this.Vendor.id)
      .then(
        function(response) {
          this.vendorDepartment = response.data;

          //check if department is available today
          this.vendorDepartment.forEach((e) => {
            // if (JSON.parse(e.config).working_days) {
            //   if (JSON.parse(e.config).working_days[day].active) {
            this.departmentFiltered.push(e);
            //   }
            // } else {
            //   this.departmentFiltered.push(e);
            // }
          });
          if (this.departmentFiltered.length <= 1) {
            this.initSelected();
          }
        }.bind(this)
      )
      .catch(
        function(response) {
          console.log(response);
        }.bind(this)
      )
      .finally(
        function() {
          this.showLoading = false;
        }.bind(this)
      );

    //
    if (this.$i18n.locale == "en") {
      this.datepicker_config.language = en;
    } else if (this.$i18n.locale == "ar") {
      this.datepicker_config.language = ar;
    } else if (this.$i18n.locale == "fr") {
      this.datepicker_config.language = fr;
    }
    this.modal.title = this.$t("AppointmentBookedSuccessffullyTitle");
    this.modal.message = this.$t("AppointmentBookedSuccessffullyMessage");
    this.modal.confirmationButton = this.$t(
      "AppointmentBookedSuccessffullyButton"
    );

    this.danger_modal.title = this.$t("AppointmentBookFailedTitle");
    this.danger_modal.hint = this.$t("AppointmentBookFailedHint");
    this.danger_modal.message = this.$t("AppointmentBookFailedMessage");
    this.danger_modal.confirmationButton = this.$t(
      "AppointmentBookFailedButton"
    );
  },
  methods: {
    totalDuration() {
      let duration = 0;
      this.selected.services.forEach(function(obj) {
        obj.durationToSend = obj.duration * obj.qte;
      });

      return duration;
    },
    getQuantityServices(index, service_id, duration) {
      let obj = {
        index: index,
        id: service_id,
        qte: 1,
        duration: duration,
        durationToSend: 0,
      };
      let indexExists = this.selected.services.findIndex(
        (o) => o.id === obj.id
      );
      if (indexExists === -1) {
        this.selected.services.push(obj);
      } else {
        this.selected.services.splice(indexExists, 1);
      }
      $(".plus" + index).show();
    },
    testOnDepartment() {
      this.getDepartmentServices();
      //test if members must be selected
      this.selected.department.config !== null
        ? (this.must_select_member = JSON.parse(
            this.selected.department.config
          ).must_select_member)
        : (this.must_select_member = 0);

      //
      this.memberArray = this.selected.department.dep_members.filter((obj) => {
        obj.fullname = obj.fname + " " + obj.lname;
        return obj.is_bookable == 1;
      });
      if (this.must_select_member) {
        if (
          this.selected.department.can_select_member == true &&
          this.selected.member == null
        ) {
          this.displayMember = true;
          this.displayServices = false;
        } else if (
          this.selected.department.can_select_member == true &&
          this.selected.member !== null
        ) {
          this.displayMember = true;
          this.displayServices = true;
        } else {
          this.displayMember = true;
          this.displayServices = true;
        }
      } else {
        if (this.selected.department.can_select_member == true) {
          this.displayMember = true;
        } else {
          this.displayMember = true;
          this.displayServices = true;
        }
      }
    },
    testOnMember() {
      if (this.must_select_member) {
        if (this.selected.member !== null) {
          this.displayServices = true;
        } else {
          this.displayServices = false;
        }
      }
    },
    DangerModalConfirmed() {
      this.danger_modal.active = false;
    },
    ModalConfirmed() {
      window.location.href = "/";
    },
    InternalIDModalConfirmed() {
      this.internalIDModal.active = false;
    },
    getDepartmentServices() {
      this.services = this.selected.department.services;
    },
    bookAppointment() {
      if (this.internalID == null || this.internalID === "") {
        this.internalIDModal.active = true;
        return
      }
      this.bookEnabled = false;
      $("#PreLoader").show();

      let services = this.selected.services
        .map(function(obj) {
          return obj.id + "-qte:" + obj.qte;
        })
        .join(",");

      let data = new FormData();
      data.append("business_id", this.Vendor.id);
      data.append("services", services);
      data.append(
        "department_id",
        this.selected.department ? this.selected.department.id : null
      );
      data.append(
        "member_id",
        this.selected.member ? this.selected.member.id : -1
      );
      data.append(
        "start_datetime",
        moment(this.selected.date).format("YYYY-MM-DD") +
          " " +
          this.selected.slot
      );
      data.append(
        "end_datetime",
        moment(this.selected.date).format("YYYY-MM-DD") +
          " " +
          this.selected.slot
      );

      data.append("_method", "PUT");

      bookingService
        .createBooking(data)
        .then(
          function(data) {
            this.modal.active = true;
            this.modal.hint =
              this.selected.slot +
              ", " +
              moment(this.selected.date).format("dddd") +
              " " +
              moment(this.selected.date).format("DD MMMM YYYY");

            this.selected.department = null;
            this.selected.member = null;
            this.selected.slot = null;
            this.selected.services = [];
          }.bind(this)
        )
        .finally(
          function() {
            this.bookEnabled = true;
            $("#PreLoader").hide();
          }.bind(this)
        )
        .catch(
          function() {
            this.danger_modal.active = true;
          }.bind(this)
        );
    },
    getAvailableSlots() {
      this.loading_slots = true;
      this.selected.slot = null;

      let data = {
        business_id: this.Vendor.id,
        date: moment(this.selected.date).format("YYYY-MM-DD"),
        department: this.selected.department
          ? this.selected.department.id
          : null,
        selected_member: this.selected.member ? this.selected.member.id : -1,
        user: this.User ? this.User.id : null,
      };

      bookingService
        .getAvailability(data)
        .then(
          function(data) {
            this.booking_slots = data.slots;
            this.loading_slots = false;
          }.bind(this)
        )
        .catch(
          function(ex) {
            this.booking_slots = [];
            this.loading_slots = false;
          }.bind(this)
        );
    },
    specifyBookingDays() {
      this.loading_dates = true;
      if (this.selected.member) {
        this.booking_days = this.selected.member.booking_days;
      } else if (this.selected.member) {
        this.booking_days = this.selected.department.booking_days;
      } else {
        this.booking_days = this.Vendor.booking_days;
      }

      //Disable non-working days
      this.datepicker_config.days = [];

      this.booking_days.forEach((obj, index) => {
        if (obj.active == 0) {
          this.datepicker_config.disabled_dates.days.push(
            index == 6 ? 0 : index + 1
          );
        }
      });

      //Disable Holidays
      this.datepicker_config.ranges = [];

      this.Vendor.holidays.map((obj) => {
        if (
          obj.member_id == null ||
          obj.member == null ||
          (this.selected.member && obj.member_id == this.selected.member.id)
        ) {
          let range = {};
          range["from"] = new Date(obj.start_date);
          range["to"] = new Date(obj.end_date);
          this.datepicker_config.disabled_dates.ranges.push(range);
        }
      });

      //Book J-?
      this.datepicker_config.disabled_dates.from = null;

      if (this.Vendor.max_booking_days_before >= 0) {
        let i = 0;
        let searched_day = new Date().getDay();
        let max_booking_days_before = this.Vendor.max_booking_days_before;
        while (i < this.Vendor.max_booking_days_before) {
          if (this.booking_days[searched_day].active == 0) {
            max_booking_days_before++;
          } else {
            i++;
          }
          searched_day = searched_day == 6 ? 0 : searched_day + 1;
        }
        this.datepicker_config.disabled_dates.from = new Date().addDays(
          max_booking_days_before
        );
      }

      this.loading_dates = false;
      this.getAvailableSlots();
    },
    backBtn() {
      this.selected.services = [];
      this.selected.date = new Date();
      this.selected.slot = null;

      if (this.step > 1) {
        this.step--;
        this.initSelected();
      } else {
        this.goBack();
      }
    },
    goBack() {
      this.$emit("goBack");
    },
    initSelected() {
      if (this.vendorDepartment.length == 1) {
        this.selected.department = this.vendorDepartment[0];
        this.testOnDepartment();
        if (this.selected.department.dep_members == 1) {
          this.testOnMember();
          this.selected.member = this.selected.department.dep_members[1];
          this.selected.show_dep_and_members = false;
        } else if (this.selected.department.dep_members == 0) {
          this.selected.member = null;
          this.selected.show_dep_and_members = false;
        }
      }
    },
  },
};
</script>

<style lang="scss">
.vdp-datepicker__calendar {
  // width: 100% !important;
}
.vdp-datepicker {
  position: relative;
  text-align: center;
  transform: translate(-150px, 0px);
  .selected {
    background: var(--primary) !important;
    color: var(--primary-font) !important;
  }
}
.vs--searchable .vs__dropdown-toggle {
  height: 40px !important;
}
.day-header,
.day__month_btn,
.month__year_btn {
  font-weight: bold;
  color: var(--primary);
}
.cell:hover {
  border: 1px solid var(--primary) !important;
}
.select {
  z-index: 999;
}
ul {
  z-index: 9999990 !important;
  li {
    z-index: 9999999 !important;
  }
}

.datetime-picker input[data-v-a46a390c] {
  width: 150px;
  height: 38px;
}

.section-loader {
  width: 100%;
  text-align: center;
  img {
    width: 50px;
  }
}

#LandingBookings {
  //padding: 15px 0px 15px 20px;
  //overflow-y: hidden !important;
  div {
    .header {
      div {
        label {
          color: var(--primary);
          font-style: normal;
          font-weight: 600;
          font-size: 15px;
          margin-left: 5px;
        }
      }
      div:first-child {
        padding-right: 5px;
      }
      div:last-child {
        padding-left: 5px;
      }
    }

    .services {
      width: 100%;
      margin-top: 40px;
      margin-left: -5px;
      label {
        color: var(--primary);
        font-style: normal;
        font-weight: 600;
        font-size: 15px;
        margin-left: 5px;
      }
      .search {
        display: flex;
        width: 100%;
        margin-bottom: 30px;
        margin-top: 5px;
        input {
          height: 40px;
          width: 100%;
          border: 1px solid #ddd;
          padding: 0 10px;
          border-radius: 5px 0 0 5px;
        }
        button {
          width: 40px;
          height: 40px;
          border-radius: 0 5px 5px 0;
          background: var(--primary);
          color: var(--primary-font);
          outline: none;
          outline: hidden;
        }
        button:hover {
          background: var(--primary-hover);
        }
      }

      .service {
        margin-top: 10px;
        // padding: 0 10px;
        label {
          font-size: 14px;
          letter-spacing: 1px;
          cursor: pointer;
        }
        .checkbox {
          float: right;
          cursor: pointer;
        }
        .vs-checkbox-primary input:checked + .vs-checkbox {
          background: var(--primary);
          border-color: var(--secondary);
          outline-color: var(--secondary);
          outline: 2px solid #fff !important;
          border: none;
          padding-top: 3px;
        }

        .vs-checkbox--check .vs-icon {
          /* color: #054479 !important; */
          font-weight: bold;
        }
      }
    }

    .calendar {
      text-align: left !important;
      label {
        color: var(--primary);
        font-style: normal;
        font-weight: 600;
        font-size: 15px;
      }
    }
    .slots {
      margin-bottom: 10px;
      width: 100%;
      div {
        text-align: center;
        .slot {
          display: inline-block;
          background: #fff;
          font-size: 14px;
          border-radius: 20px;
          border: 1px solid var(--special-font);
          color: var(--special-font);
          transition: 0.3s;
          padding: 7px 20px;
          margin-bottom: 10px;
          letter-spacing: 1px;
          margin-right: 10px;
          cursor: pointer;
        }
        .slot:hover {
          transform: scale(1.05);
        }
        .slot_disabled {
          background: #888;
          color: #fff;
          cursor: not-allowed;
          pointer-events: none;
        }
        .slot_selected {
          background: var(--secondary);
          color: var(--secondary-font);
          border: 1px solid var(--secondary);
        }
        .slot-danger {
          background: var(--danger);
          color: var(--danger-font);
          border: 1px solid var(--danger);
        }
      }
    }
  }

  .buttons {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 0 0;
    z-index: 1;
    .button {
      border: 3px solid var(--primary);
      border-radius: 100px;
      height: 40px;
      transition: 0.3s;
      color: var(--primary);
      background: #fff;
      font-size: 15px;
      width: 230px;
      z-index: 99;
    }
    .button:hover {
      transform: scale(1.02);
    }
    .button-filled {
      background: var(--primary);
      color: var(--primary-font);
    }
  }
}
.space-under2 {
  margin-bottom: 45px;
}
.space-under {
  margin-bottom: 75px;
}
.yaraab {
  left: 50%;
}

.buttonQte {
  width: 20px;
  height: 22px;
  background-color: var(--secondary);
  border-style: none;
  color: white;
  margin: 0 10px;
  font-size: 16px;
}

// checkbox style
.checkbox {
  font-family: sans-serif;
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  letter-spacing: 1px;
  cursor: pointer;
  justify-content: space-between;
  margin: 16px 0;
  padding: 0 5px;
}
.checkbox input {
  display: none;
}
.checkbox input:checked ~ .checkbox__mark svg {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1);
}
.checkbox__mark {
  margin-right: 0.5rem;
  position: relative;
  width: 20px;
  height: 20px;
  border: 2px solid rgb(110, 109, 109);
}
.checkbox__mark svg {
  position: absolute;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.5);
  width: 80%;
  height: auto;
  transition: all ease 0.2s;
  opacity: 0;
}
.checkbox--disabled {
  color: grey;
  pointer-events: none;
}
.checkbox--disabled .checkbox__mark {
  border-color: grey;
}
.checkbox--disabled .checkbox__mark {
  border-color: grey;
}
</style>
